import { EnvelopeSimple } from '@phosphor-icons/react';
import styled from '@emotion/styled';
import { Chip } from 'components/chip/Chip';

export const EmailChip = ({ email }: { email: string | undefined }) => (
  <ChipWrapper>
    <Chip
      component="span"
      label={email ?? ''}
      startItems={<EnvelopeSimple size={18} />}
      size="sm"
      color="brand"
      isTooltip={false}
      isBackgroundFilled
    />
  </ChipWrapper>
);

const ChipWrapper = styled.span`
  margin-bottom: ${({ theme }) => theme.s.md};
`;

export const ProgressDots = styled.div<{ top?: number }>`
  display: flex;
  gap: ${({ theme }) => theme.s.xs};
  margin-bottom: ${({ theme }) => theme.s.md};
  ${p => (p.top != null ? `margin-top: ${p.top}px;` : '')}
`;

export const ProgressDot = styled.span<{ active: boolean }>`
  display: block;
  width: ${p => (p.active ? '18px' : p.theme.s.xs)};
  height: ${({ theme }) => theme.s.xs};
  border-radius: ${({ theme }) => theme.s.xxs};
  background-color: ${p => (p.active ? p.theme.palette.primary.main : p.theme.palette.fg.senary)};
`;
